const userLeaveStore = {
	namespaced: true,
	state: {
		step: 1,
	},
	getters: {},
	mutations: {
		setStep(state, data) {
			state.step = data;
		},
	},
};

export default userLeaveStore;
